import { useEffect, useState } from 'react';
import getWindow from '../utils/getWindow';
const patchHistory = method => {
  const history = getWindow().history;
  const original = history[method];
  history[method] = function (...args) {
    const result = original.apply(this, args);
    const event = new Event(method.toLowerCase());
    event.state = args;
    getWindow().dispatchEvent(event);
    return result;
  };
};
patchHistory('pushState');
patchHistory('replaceState');
const buildState = trigger => {
  const {
    state,
    length
  } = getWindow().history;
  const {
    hash,
    host,
    hostname,
    href,
    origin,
    pathname,
    port,
    protocol,
    search
  } = getWindow().location;
  return {
    trigger,
    state,
    length,
    hash,
    host,
    hostname,
    href,
    origin,
    pathname,
    port,
    protocol,
    search
  };
};
const useLocation = () => {
  const [state, setState] = useState(buildState('load'));
  useEffect(() => {
    const onPopState = () => setState(buildState('popstate'));
    const onPushState = () => setState(buildState('pushstate'));
    const onReplaceState = () => setState(buildState('replacestate'));
    window.addEventListener('popstate', onPopState);
    window.addEventListener('pushstate', onPushState);
    window.addEventListener('replacestate', onReplaceState);
    return () => {
      window.removeEventListener('popstate', onPopState);
      window.removeEventListener('pushstate', onPushState);
      window.removeEventListener('replacestate', onReplaceState);
    };
  }, []);
  return state;
};
export default useLocation;